import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import InvocationsList from "@/components/Workflow/InvocationsList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryInvocations',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        const { currentUser } = storeToRefs(useUserStore());
        const { getHistoryNameById } = useHistoryStore();
        const historyName = computed(() => getHistoryNameById(props.historyId));
        return { __sfc: true, props, currentUser, getHistoryNameById, historyName, InvocationsList };
    }
});
